var $ = require('jquery'), jQuery = $
toastr = require('toastr');
dropzone = require('dropzone');
selectize = require('selectize');
html2canvas = require('html2canvas');
Ractive = require('ractive');
Format = require('./Project/ERP/format.js');
Language = require('./Project/ERP/language-rs.js');
Client = require('./Project/ERP/client.js');
Definitions = require('./Project/ERP/definitions.js');
Global = Client.getGlobal();
SiteLng = Language.getDefault();
Client.setSession();

// Config
Ractive.DEBUG = ((Global.Behavior)? Global.Behavior.echoTest: false);
Ractive.adaptors.Ractive = require('ractive-ractive');
//Ractive.adaptors.Load = require('ractive-load');
Ractive.defaults.adapt = ['Ractive'];
Ractive.defaults.isolated=true;
Ractive.defaults.lazy=false;
// Functions
Ractive.defaults.data.format = Format.format;
Ractive.defaults.data.session = Global.Session;
// Procedures
Ractive.defaults.cmd = Client.Cmd;
Ractive.defaults.isEcho = Client.isEcho;
Ractive.defaults.setDisplay = Client.setDisplay;
// Elements
Ractive.components['Element-Input'] = require('ractive-component!./Project/ERP/Element/Input.html');
Ractive.components['Element-Wait'] = require('ractive-component!./Project/ERP/Element/Wait.html');
Ractive.components['Element-Login'] = require('ractive-component!./Project/ERP/Element/Access.html');
Ractive.components['Element-NoAuth'] = require('ractive-component!./Project/ERP/Element/NoAuth.html');
Ractive.components['Element-Actions'] = require('ractive-component!./Project/ERP/Element/Actions.html');
Ractive.components['Element-Simple'] = require('ractive-component!./Project/ERP/Element/DetailsSimple.html');
Ractive.components['Element-ReadOnly'] = require('ractive-component!./Project/ERP/Element/DetailsReadOnly.html');
Ractive.components['Element-InfoSelect'] = require('ractive-component!./Project/ERP/Element/InfoSelect.html');
// Pages 
Ractive.components['login'] = require('ractive-component!./Project/ERP/Page/Login.html');
Ractive.components['logout'] = require('ractive-component!./Project/ERP/Page/Logout.html');
// Pages ERP
Ractive.components['root'] = require('ractive-component!./Project/ERP/Display/Root.html');
Ractive.components['list'] = require('ractive-component!./Project/ERP/Page/List.html');
Ractive.components['404'] = require('ractive-component!./Project/ERP/Page/404.html');
Ractive.components['pocetna'] = require('ractive-component!./Project/ERP/Page/Menu.html');
Ractive.components['menu'] = require('ractive-component!./Project/ERP/Page/Menu.html');
Ractive.components['profil'] = require('ractive-component!./Project/ERP/Page/Profile.html');
Ractive.components['firma'] = require('ractive-component!./Project/ERP/Page/Owner.html');
Ractive.components['mail'] = require('ractive-component!./Project/ERP/Page/Empty.html');
Ractive.components['podesavanje'] = require('ractive-component!./Project/ERP/Page/Empty.html');
Ractive.components['admins'] = require('ractive-component!./Project/ERP/Page/Admin.html');

Ractive.components['Part-Head'] = require('ractive-component!./Project/ERP/Part/Head.html');
Ractive.components['Part-MenuLeft'] = require('ractive-component!./Project/ERP/Part/MenuLeft.html');
Ractive.components['Part-Foot'] = require('ractive-component!./Project/ERP/Part/Foot.html');
Ractive.components['Part-Chat'] = require('ractive-component!./Project/ERP/Part/Chat.html');
Ractive.components['Part-Task'] = require('ractive-component!./Project/ERP/Part/Task.html');

// Display
$(function () {
  $(".ex-frame").each(function () {
    var fFrame = $(this).data("frame");
    var fId = $(this).attr('id');
    if ((Global) && (Global.Behavior) && (Global.Behavior.echoTest)) {
      console.log('Frame:', fFrame, fId);
      $(this).html("Found this one (" + fId + ")");
    }
    Client.setDisplay({ Frame: fFrame, Id: fId });
  });
});


//////////////////
// WEBPACK FOOTER
// ./ractive/app.erp.js
// module id = 0
// module chunks = 0